import { LogOut } from "lucide-react";
import { NavLink } from "react-router";
import type { Workspace } from "@/api/types";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { navItems } from "./nav";
import { ThemeMenu } from "./ThemeMenu";
import { ThemeToggle } from "./ThemeToggle";
import { WorkspaceSwitcher } from "./WorkspaceSwitcher";

/** Navegação lateral: completa no desktop; recolhida (só ícones rotulados) no tablet. */
export function SideNav({
  workspace,
  workspaces,
  email,
  platformAdmin,
  collapsed,
  onSignOut,
}: {
  workspace: Workspace;
  workspaces: Workspace[];
  email?: string;
  platformAdmin: boolean;
  collapsed: boolean;
  onSignOut: () => void;
}) {
  return (
    <aside
      className={cn(
        "sticky top-0 flex h-dvh shrink-0 flex-col gap-6 border-r border-border bg-surface py-6",
        collapsed ? "w-20 items-center px-3" : "w-68 px-4",
      )}
    >
      <div className={cn(collapsed ? "" : "px-2")}>
        <Logo compact={collapsed} />
      </div>
      {!collapsed && <WorkspaceSwitcher current={workspace} workspaces={workspaces} />}
      <nav aria-label="Principal" className="flex flex-col gap-0.5">
        {navItems(platformAdmin).map(({ to, label, Icon, end }) => (
          <NavLink
            key={label}
            to={to}
            end={end}
            aria-label={collapsed ? label : undefined}
            title={collapsed ? label : undefined}
            className={({ isActive }) =>
              cn(
                "flex min-h-11 items-center gap-3 rounded-control text-[15px] font-medium",
                "focus-visible:outline-2 focus-visible:outline-accent",
                collapsed ? "size-12 justify-center" : "px-3",
                isActive
                  ? "bg-accent-soft text-accent-soft-ink"
                  : "text-muted hover:bg-surface-2 hover:text-ink",
              )
            }
          >
            <Icon aria-hidden="true" className="size-5 shrink-0" />
            {!collapsed && label}
          </NavLink>
        ))}
      </nav>
      <div className={cn("mt-auto flex flex-col gap-3", collapsed && "items-center")}>
        {collapsed ? <ThemeMenu /> : <ThemeToggle />}
        <div className={cn("flex items-center gap-2", collapsed ? "flex-col" : "px-1")}>
          {!collapsed && <span className="min-w-0 flex-1 truncate text-sm text-muted">{email}</span>}
          <Button variant="ghost" size="icon" aria-label="Sair" title="Sair" onClick={onSignOut}>
            <LogOut aria-hidden="true" className="size-5" />
          </Button>
        </div>
      </div>
    </aside>
  );
}
